// providermanagement.action.ts
import { createAsyncThunk } from '@reduxjs/toolkit'
import { getAllAppointmentTypes } from '@services/api/appointment-type.api'
import { IAppointmentType } from '@dataTypes/appointment.type'

export const fetchAllAppointmentTypes = createAsyncThunk<
  IAppointmentType[],
  void,
  {
    rejectValue: string
  }
>('api/appointmenttype/get/all', async (_, thunkAPI) => {
  // Set a default value for the argument
  try {
    const response = await getAllAppointmentTypes()

    if (response.statusCode !== 200) {
      return thunkAPI.rejectWithValue(response.message)
    }

    if (
      response.data &&
      'appointment_types' in response.data &&
      Array.isArray(response.data.appointment_types)
    ) {
      return response.data.appointment_types as IAppointmentType[]
    }

    return thunkAPI.rejectWithValue(
      'Appointment types not found in the response',
    )
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.message || 'An error occurred')
  }
})
